import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * The one "you will watch a video" glyph: a screen with a play triangle in it.
 *
 * Module 83 (WP-83.12) drew it for SOLVE IT (user, 2026-10-04: a bare ▶ and the
 * words "1 ad" did not say an ad plays). Module 93 (WP-93.2) moved it here so
 * every button that plays a rewarded ad — Blockway's popups and the shared Shop
 * — draws the same mark. It paints in `currentColor`, so each surface tints it.
 */
export function AdVideoIcon({ size = 16, className }) {
    return (_jsxs("svg", { className: className, width: size, height: size, viewBox: "0 0 24 24", "aria-hidden": "true", focusable: "false", children: [_jsx("rect", { x: "2", y: "4.5", width: "20", height: "15", rx: "3.5", fill: "none", stroke: "currentColor", strokeWidth: "2.4" }), _jsx("path", { d: "M10 8.6v6.8l5.8-3.4z", fill: "currentColor" })] }));
}
